// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing145({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/145/1.gif`}
      videoPath={`${process.env.REACT_APP_CDN_BASE}/images/145/2.mp4`}
      qOptionColor="blue"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_07.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing145;
